<template>
  <div id="app">
    <Navbar></Navbar>
    <div class="main-content">
      <router-view/>
    </div>
  </div>
</template>

<script>
import API from "@/services/api";
import Navbar from "./components/Navbar";

export default {
  name: "App",
  components: {
    Navbar
  },
  async beforeMount() {
    console.log("Environment: " + EnvironmentConstants.ENVIRONMENT_NAME);
    try {
      const client = await API.GetClientVersion();
      console.log("Client version " + client);
    } catch (err) {
      console.log("Couldn't get client version");
    }
  }
};
</script>

<style>
@import url("https://fonts.googleapis.com/css?family=Open+Sans");

#app {
  font-family: "Open Sans", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
.main-content {
  padding-top: 20px;
}
.val-error {
  color: red;
}
h1 {
  color: #17435e !important;
}
.btn.btn-primary {
  background-color: #5ab8dc !important;
  border-color: #5ab8dc !important;
}
.btn.btn-primary:hover {
  background-color: #51a2c2 !important;
  border-color: #45859e !important;
}
.btn-primary:not(:disabled):not(.disabled):active,
.btn-primary:not(:disabled):not(.disabled).active,
.show > .btn-primary.dropdown-toggle {
  background-color: #45859e !important;
  border-color: #396f85 !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue